<!-- LARGEUR D'UN CHAMP : data.width, en NOMBRE DE CARACTÈRES que le champ doit montrer (voir
     cufWidth). Un code APE fait « 4772A », cinq signes ; le rendre dans 132 px, c'est le mettre
     dans une boîte quatre fois trop grande où l'œil ne trouve plus le bord de la valeur. -->
@if (cufsStructure) {
  <div class="cufzone "  [formGroup]="cufGroup">
    <!-- @if de visibilité AVANT la boîte du champ, et non un [hidden] dessus : un champ hors
         sujet ne doit pas laisser d'espace vide dans la rangée. Voir isCufVisible. -->
    @for (cuf of cufsStructure; track cuf.id) {
      @if (isCufVisible(cuf)) {
      <div class="cuf-item" [class.inline]="inline">
        <!-- L'infobulle de l'étiquette est la CONSIGNE (data.hint, ou nom + unité + bornes) ;
             celle du champ dit la règle enfreinte quand il est en faute. Voir applyRules. -->
        <label class="cuf-label" [attr.title]="hint(cuf)">
          {{ cuf.name }}
          @if (cuf.data?.mandatory) { <span class="cuf-required">*</span> }
        </label>

        <!-- INT : saisie FILTRÉE (chiffres, signe de tête) comme le type FK, et non un
             type="number" step="1" qui laissait taper « 1.75 ». L'unité (data.unit) est un
             suffixe collé au champ, dans la même boîte que lui. -->
        @if (cuf.data?.typ === 'INT') {
          @if (mode === 'selector' && cuf.data?.is_sortable) {
            <div class="price-inputs smart-input">
              <input type="number" class="smart-input price-input" placeholder="Min" [formControlName]="'g'+cuf.id" step="1">
              <span class="price-separator">—</span>
              <input type="number" class="smart-input price-input" placeholder="Max" [formControlName]="'l'+cuf.id" step="1">
            </div>
          } @else {
            <span class="cuf-field" [class.invalid]="isInvalid(cuf)">
              <input type="text" inputmode="numeric" autocomplete="off" class="smart-input inputNumber"
                [formControlName]="''+cuf.id" [style.width]="cufWidth(cuf)" [attr.title]="title(cuf)" [attr.aria-label]="cuf.name"
                (keydown)="blockNonInteger($event)" (input)="sanitizeInt(''+cuf.id, $event)" (change)="onCufInt(''+cuf.id)">
              @if (unit(cuf); as u) { <span class="cuf-unit">{{ u }}</span> }
            </span>
          }
        }
        @if (cuf.data?.typ === 'FLOAT') {
          @if (mode === 'selector' && cuf.data?.is_sortable) {
            <div class="price-inputs smart-input">
              <input type="number" class="smart-input price-input" placeholder="Min" [formControlName]="'gte_'+cuf.id">
              <span class="price-separator">—</span>
              <input type="number" class="smart-input price-input" placeholder="Max" [formControlName]="'lte_'+cuf.id" >
            </div>
          } @else {
            <span class="cuf-field" [class.invalid]="isInvalid(cuf)">
              <input type="number" class="smart-input inputFloat" [formControlName]="''+cuf.id" step="0.01" [style.width]="cufWidth(cuf)"
                [attr.min]="cuf.data?.min ?? null" [attr.max]="cuf.data?.max ?? null" [attr.title]="title(cuf)" [attr.aria-label]="cuf.name">
              @if (unit(cuf); as u) { <span class="cuf-unit">{{ u }}</span> }
            </span>
          }
        }
        @if (cuf.data?.typ === 'STRING') {
          <input type="text" class="smart-input inputString" [class.invalid]="isInvalid(cuf)" [formControlName]="''+cuf.id" [placeholder]="cuf.name ?? ''" [style.width]="cufWidth(cuf)" [attr.title]="title(cuf)">
        }
        <!-- FK : identifiant d'une ligne d'une autre table (cuf.data.fk_table), saisi à la main.
             Volontairement AUCUNE vérification d'existence en base — simple entier.
             type="text" + filtrage : voir blockNonInteger/sanitizeInt (un type="number" laisse
             afficher des lettres sous Firefox et accepte 1e3 / 1.5). -->
        @if (cuf.data?.typ === 'FK') {
          <input type="text" inputmode="numeric" autocomplete="off" class="smart-input inputFk"
            [formControlName]="''+cuf.id" [style.width]="cufWidth(cuf)"
            [attr.aria-label]="cuf.name" [attr.title]="'Identifiant ' + (cuf.data?.fk_table ?? '')"
            (keydown)="blockNonInteger($event)" (input)="sanitizeInt(''+cuf.id, $event)" (change)="onCufInt(''+cuf.id)">
        }
        <!-- DATE : le control garde une date nue « YYYY-MM-DD », le picker n'est qu'un moyen de saisie -->
        @if (cuf.data?.typ === 'DATE') {
          <span class="cuf-date">
            <input class="smart-input inputDate" placeholder="JJ/MM/AAAA" [style.width]="cufWidth(cuf)"
              [matDatepicker]="cufPicker" [formControlName]="''+cuf.id" [attr.aria-label]="cuf.name"
              (dateChange)="onCufDate(''+cuf.id, $event.value)">
            <mat-datepicker-toggle [for]="cufPicker"></mat-datepicker-toggle>
            <mat-datepicker #cufPicker></mat-datepicker>
          </span>
        }
        @if (cuf.data?.typ === 'BOOLEAN') {
          <button type="button" class="cuf-bool-btn" (click)="cycleBoolCuf(''+cuf.id)" [attr.aria-label]="cuf.name">
            @if (cufGroup.get(''+cuf.id)?.value === true) {
              <mat-icon class="success">check_box</mat-icon>
            } @else if (cufGroup.get(''+cuf.id)?.value === false) {
              <mat-icon class="error">check_box_outline_blank</mat-icon>
            } @else {
              <mat-icon class="cuf-unset">indeterminate_check_box</mat-icon>
            }
          </button>
        }
        @if (cuf.data?.typ === 'RADIO') {
          <div class="toggle-group check">
            @for (val of cuf.data?.values; track val) {
              <input type="radio"
                [name]="''+cuf.id"
                [id]="'cuf-' + cuf.id + '-' + val"
                [value]="val"
                [formControlName]="''+cuf.id"
                (click)="deselRadioCuf(''+cuf.id, val, $event)">
              <label [for]="'cuf-' + cuf.id + '-' + val"
                [class.success]="cufGroup.get(''+cuf.id)?.value === val"
                [style.color]="!cufGroup.get(''+cuf.id)?.value ? 'rgba(0,0,0,0.38)' : null">{{ val }}</label>
            }
          </div>
        }
        <!-- LOV : liste en dur (data.values, valeur = la chaîne) ou empruntée à un référentiel
             c_values (data.values_id, valeur = l'id de l'élément) — voir getCufLovItems.
             compareWith tolérant : une valeur héritée peut être en base sous forme de chaîne
             (« 20 ») là où le référentiel rend un entier. Sans lui, le select s'affiche vide
             alors que la fiche porte bien une valeur, et la refermer l'effacerait. -->
        @if (cuf.data?.typ === 'LOV') {
          <!-- 240 px : « Association loi 1901 » et « Personne physique » tiennent en entier, flèche
               comprise. À 200 px le libellé se coupait — et un libellé coupé dans une liste de
               sigles proches (SELARL / SELAS / SELASU) se lit de travers. -->
          <smart-select
            [items]="getCufLovItems(cuf)"
            bindLabel="label"
            bindValue="value"
            [compareWith]="lovCompare"
            [formControlName]="''+cuf.id"
            [placeholder]="(cuf.name ?? '') + ' ?'"
            width="240px"
            height="2rem">
          </smart-select>
        }
      </div>
      }
    }
  </div>
}
